var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRejectedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Status---Rejected",
    transform: "translate(-698.000000, -246.000000)",
    fill: "#B30016",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(115.000000, 117.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M605,129 C592.868571,129 583,138.869305 583,151 C583,163.130695 592.868467,173 605,173 C617.131533,173 627,163.130695 627,151 C627,138.869305 617.131533,129 605,129 Z M605,169.48 C594.810867,169.48 586.52,161.1904 586.52,151 C586.52,140.8096 594.810867,132.52 605,132.52 C615.189133,132.52 623.48,140.8096 623.48,151 C623.48,161.1904 615.189133,169.48 605,169.48 Z M614.138186,144.47453 L608.05312,150.560088 L614.138609,156.645645 C614.860464,157.367509 614.860464,158.536921 614.138609,159.258795 C613.777264,159.61932 613.304556,159.8 612.831837,159.8 C612.359119,159.8 611.886411,159.61932 611.525489,159.258383 L605.44,153.173248 L599.354511,159.258806 C598.993579,159.619331 598.520871,159.8 598.048163,159.8 C597.575455,159.8 597.102736,159.619331 596.741814,159.258394 C596.019959,158.536531 596.019959,157.367118 596.741814,156.645244 L602.82688,150.560109 L596.741391,144.474551 C596.019536,143.752688 596.019536,142.583275 596.741391,141.861401 C597.463247,141.139528 598.632646,141.139538 599.354511,141.861401 L605.44,147.946959 L611.525489,141.861401 C612.247344,141.139538 613.416743,141.139538 614.138609,141.861401 C614.860474,142.583265 614.860464,143.752677 614.138196,144.474551 L614.138186,144.47453 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedIcon);
export default __webpack_public_path__ + "static/media/rejectedIcon.4076d05c8a3034e0ffa1b7552f9d4ee6.svg";
export { ForwardRef as ReactComponent };